import React from "react";
import { useSelector } from "react-redux";
import { StyleSheet, View, TouchableOpacity } from "react-native";

//Custom Imports
import color from "@constants/color";
import BackArrow from "@assets/svg/BackArrow";
import FetchCMSEntity from "@components/CMS/FetchCMSEntity";

const VACATION_CMS_ENTITY = "VACATION_CMS_ENTITY";
const cmsPoweredEntitiesSelector = (state) =>
  state?.configReducer?.appSettings?.cmsPoweredEntities;

const LeaveTnC = ({ navigation = {} }) => {
  const cmsPoweredEntities = useSelector(cmsPoweredEntitiesSelector);

  const goBackHandler = () => {
    navigation.goBack();
  };

  return (
    <View style={styles.container}>
      <View style={styles.topNavContainer}>
        <TouchableOpacity onPress={goBackHandler}>
          <BackArrow />
        </TouchableOpacity>
      </View>
      <FetchCMSEntity
        id={cmsPoweredEntities[VACATION_CMS_ENTITY]}
        type="PAGE"
        isPaddingVertical={false}
      />
    </View>
  );
};

export default LeaveTnC;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.white,
  },
  topNavContainer: {
    flexDirection: "row",
    height: 56,
    alignItems: "center",
    paddingHorizontal: 16,
  },
});
